(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["origin-article"]) return;
  try {
    
(() => {
  const ready = new WeakSet();
  function buildContents(scope) {
    scope.querySelectorAll('[data-journal-article]').forEach((article) => {
      if (ready.has(article)) return;
      ready.add(article);
      const content = article.querySelector('[data-journal-content]');
      const list = article.querySelector('[data-journal-toc]');
      if (!content || !list) return;
      const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
      if (headings.length < 2) {
        article.querySelector('.ea-reading__aside').hidden = true;
        article.querySelector('.ea-reading__layout').classList.add('ea-reading__layout--plain');
        return;
      }
      const links = document.createDocumentFragment();
      headings.forEach((heading, index) => {
        if (!heading.id || document.getElementById(heading.id) !== heading) {
          const base = `beitrag-abschnitt-${index + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        if (heading.tagName === 'H3') item.className = 'is-subheading';
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        links.append(item);
      });
      list.replaceChildren(links);
      article.querySelector('.ea-reading__toc').open = window.matchMedia('(min-width: 1000px)').matches;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => buildContents(document), { once: true });
  else buildContents(document);
  document.addEventListener('shopify:section:load', (event) => buildContents(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
